<h1 mat-dialog-title>{{ title }}</h1>
<div mat-dialog-content style="text-align: center" id="logout-modal">
  You will be redirected to the login screen in {{ countDown }} seconds.
  <br /><br />
  Do you want to continue working?
</div>
<div mat-dialog-actions align="end" *ngIf="countDown > 0">
  <button mat-button mat-dialog-close class="button_small" tabindex="0" (click)="keepWorking()">
    Keep Working
  </button>
  <button
    mat-button
    mat-dialog-close
    class="button_small cancel"
    (click)="logout()"
    tabindex="1"
  >
    Logout
  </button>
</div>
<div mat-dialog-actions align="end" *ngIf="countDown <= 0">
    <button mat-button mat-dialog-close class="button_small" tabindex="0" (click)="ok()">
        OK
    </button>
</div>
